<template>
  <div class="send-info">
    <van-popup
      v-model="isShow"
      position="bottom"
      :close-on-popstate="true"
    >
      <ld-header @click-left="isShow = false">
        <span slot="left" />
        寄出信息填写
      </ld-header>

      <van-cell-group>
        <van-field
          v-model="expressCompanyName"
          required
          placeholder="快递公司"
        />

        <van-field
          v-model="expressNumber"
          required
          placeholder="快递单号"
        />

        <van-field
          v-model="expressRemark"
          type="textarea"
          clearable
          autosize
          placeholder="备注信息"
        />
      </van-cell-group>

      <div style="padding: 10px 30px;">
        <ld-button
          @click="submit"
          size="lg"
          main
        >
          {{ $t('B010','保存') }}
        </ld-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { CellGroup, Cell, Popup, Field } from 'vant'
import ldButton from 'Common/ldButton'

export default {
  components: {
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    ldButton
  },
  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isShow: false,
      expressCompany: '',
      expressCompanyName: '',
      expressNumber: '',
      expressRemark: ''
    }
  },
  methods: {
    submit () {
      this.$emit('submit', {
        expressCompany: this.expressCompany,
        expressCompanyName: this.expressCompanyName,
        expressNumber: this.expressNumber,
        expressRemark: this.expressRemark
      })
    }
  },
  watch: {
    detail () {
      this.expressCompany = this.detail.expressCompany
      this.expressCompanyName = this.detail.expressCompanyName
      this.expressNumber = this.detail.expressNumber
      this.expressRemark = this.detail.expressRemark
    },
    visibility (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
}
</script>